export type Environment = "development" | "production" | "preprod" | "staging" | "sandbox";

export const getReleaseInfo = () => {
    const branch: string = process.env.BUILD_BRANCH ?? "Unknown Branch";
    const release = process.env.VERSION_HASH ?? branch;

    const isLocalhost = window.location.hostname === "localhost";
    const isPreview = branch.startsWith("pr-");

    const environment = (isLocalhost || isPreview ? "development" : process.env.ENVIRONMENT) as Environment;
    const isProductionLike = ["prod", "production", "sandbox", "preprod", "staging"].includes(
        process.env.ENVIRONMENT ?? "",
    );

    return { branch, release, isLocalhost, isPreview, isProdLike: isProductionLike, env: environment };
};
